const NOW_PLAYING_ENDPOINT = `https://api.spotify.com/v1/me/player/currently-playing`;
const RECENTLY_PLAYED_ENDPOINT = `https://api.spotify.com/v1/me/player/recently-played?limit=1`;
const TOP_TRACKS_ENDPOINT = `https://api.spotify.com/v1/me/top/tracks`;
const TOKEN_ENDPOINT = `https://accounts.spotify.com/api/token`;	


export const getAccessToken = async (venue) => {
	
	let client_id, client_secret, refresh_token, base64_token;
	switch( venue ){
		case 'southville-bristol':
			client_id = '8a595e2b3a2f49c4b2162dbb4035a657';
			client_secret = 'b90ac2f1d71a4745b506dd25e45b7760';
			refresh_token = 'AQDl9wzJMS_CX-qmVIf4G9-sHIv3JmuGdMzxTs7o_98nARZ01JPjOSxK9w99_QDLuKP1zSjdctY0SQzZJphM5tiN1OtJfVs8KIwI6J1mR_sXdojUPO0S_Q7nXxVgFhw0y_0';
			base64_token = 'OGE1OTVlMmIzYTJmNDljNGIyMTYyZGJiNDAzNWE2NTc6YjkwYWMyZjFkNzFhNDc0NWI1MDZkZDI1ZTQ1Yjc3NjA'; // Base64 encoded combination of CLIENT_ID:CLIENT_SECRET
			break;
		case 'brunswick-sq-bristol':
			client_id = '93e5e034c10c4e7b9255daa56089d154';
			client_secret = 'c33d96d7727e440baf00301c2819d173';
			refresh_token = 'AQCMJsiD4ic5Hj1egI7y98AIL-nHEIEHxi5k8aLa2pWk97Hc3pvCBl_7t2OJ1POJFvedIiE0goMvmDjzv4qF5zh8_D606nFJYzxUVPR6d3_02W-N2mQWsr--WM4b0PlnYCA';
			base64_token = 'OTNlNWUwMzRjMTBjNGU3YjkyNTVkYWE1NjA4OWQxNTQ6YzMzZDk2ZDc3MjdlNDQwYmFmMDAzMDFjMjgxOWQxNzM'; // Base64 encoded combination of CLIENT_ID:CLIENT_SECRET
			break;
		default:
			// Defaults to TMO's personal account
			client_id = '2fc66ae580f04519828c10be0a0a3b6d';
			client_secret = '8a027e57b07b49269c47ca227091a58f';
			refresh_token = 'AQAVVHW-eOE586wnoRgaAQTFLez0WS87SrKB5Y907QtoXhqy242t_fKU5K7wS-f9q-H2heHFGpihn7C0vmXMlLKUDONt0w2nHoOj27KjOmiIMyAJ8BpU48HUmrYuVe35v5Y';
			base64_token = 'MmZjNjZhZTU4MGYwNDUxOTgyOGMxMGJlMGEwYTNiNmQ6OGEwMjdlNTdiMDdiNDkyNjljNDdjYTIyNzA5MWE1OGY'; // Base64 encoded combination of CLIENT_ID:CLIENT_SECRET
			break;
	}

	const response = await fetch(TOKEN_ENDPOINT, {
		method: 'POST',
		headers: {
		Authorization: `Basic ${base64_token}`,
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		body: new URLSearchParams({
			grant_type: 'refresh_token',
			refresh_token
		})
	});

	return response.json();
};

export const getNowPlaying = async (client_id, client_secret, refresh_token, venue) => {

    const { access_token } = await getAccessToken(
        client_id,
        client_secret,
        refresh_token,
		venue
    );
	return fetch(NOW_PLAYING_ENDPOINT, {
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
    });
};

export const getRecentlyPlayed = async (client_id, client_secret, refresh_token, venue) => {
    const { access_token } = await getAccessToken(
        client_id,
        client_secret,
        refresh_token,
		venue
    );
	return fetch(RECENTLY_PLAYED_ENDPOINT, {
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
    });
};


// 
// AUTH URL FOR TMO
// https://accounts.spotify.com/authorize?client_id=2fc66ae580f04519828c10be0a0a3b6d&response_type=code&redirect_uri=http%3A%2F%2Flocalhost:3000&scope=user-read-currently-playing%20user-top-read%20user-read-recently-played
// curl -H "Authorization: Basic MmZjNjZhZTU4MGYwNDUxOTgyOGMxMGJlMGEwYTNiNmQ6OGEwMjdlNTdiMDdiNDkyNjljNDdjYTIyNzA5MWE1OGY" -d grant_type=authorization_code -d code=AQB01NFdhwrN65oJs8JaNDl1Ypm-upTdinPbHwPEoWFP8vJ4Ma16gVbSUiIPigEniRjKZNQ18-GVLJUYag4ah5eUndB54hIfTSXeBq9gzv6IkAR2rpyUkFXIuEfVb6gk67af3DzXQVMbTds5GpGQwFu1ldcfSLq5nJqSgKZYavdD-bZC9cxqxPkSUlytvLLGLBOHnaC8z4FAPk2PZ9FqqSwH7A_8TDVzD4lT5brB7pEOaUu6tAR1_of4guB4mJbL -d redirect_uri=http%3A%2F%2Flocalhost:3000 https://accounts.spotify.com/api/token
//


// 
// AUTH URL FOR CIGAR FACTORY
// https://accounts.spotify.com/authorize?client_id=8a595e2b3a2f49c4b2162dbb4035a657&response_type=code&redirect_uri=http%3A%2F%2Flocalhost:3000&scope=user-read-currently-playing%20user-top-read%20user-read-recently-played
// curl -H "Authorization: Basic OGE1OTVlMmIzYTJmNDljNGIyMTYyZGJiNDAzNWE2NTc6YjkwYWMyZjFkNzFhNDc0NWI1MDZkZDI1ZTQ1Yjc3NjA" -d grant_type=authorization_code -d code=AQDzejc0Kb77MQbaUP9OzA4JlrFAN99yoJRUN6c3XFtPBsqrBQo8ZT1Pz5xG82kTlnDv64p--SviC-KkdfrEeCMPeoUldLYGQUTGGXj_MbgOFw5cbMMcid1AFYDCNWbVcz1j3xyKNzC2I7HMoqjo69YmRPemK65qJmi_XCj-axKjcOTRhmbhKeKizSEZuM0ijxKGfQGU6Qh_BbgLu3XtNn3RyOf6QbklvtXyPyjREK9WMazTVj8XvL5Kk7BDyw-G -d redirect_uri=http%3A%2F%2Flocalhost:3000 https://accounts.spotify.com/api/token
//

// 
// AUTH URL FOR BRUNSWICK
// https://accounts.spotify.com/authorize?client_id=93e5e034c10c4e7b9255daa56089d154&response_type=code&redirect_uri=http%3A%2F%2Flocalhost:3000&scope=user-read-currently-playing%20user-top-read%20user-read-recently-played
// curl -H "Authorization: Basic OTNlNWUwMzRjMTBjNGU3YjkyNTVkYWE1NjA4OWQxNTQ6YzMzZDk2ZDc3MjdlNDQwYmFmMDAzMDFjMjgxOWQxNzM" -d grant_type=authorization_code -d code=AQDYG6-QXOXVzKtec7yiUhnsCJB6C1S47ywwF7XHZ8LalIA0vqFzdMksNRJvBES-HqPXMsORZIIImUOgUoZiuy3bYXxOd9tz1m88arxteE_WhGSVuP79bEdLNxHknu106pvhcdxU7DaFmsuQHG2sce9_eRCGZVZdHiwNdQwAK-6BtMDW9vU1Or5NePQZpugX3HFL8FD0YYnbISGVb-wjJ6L25VOOjcbec1R2BflRu0iqxEkbRe_NgnvUTOrBenNP -d redirect_uri=http%3A%2F%2Flocalhost:3000 https://accounts.spotify.com/api/token
//


// Access token: BQBhszncDrqKN_XyblsGgSr0EZwiSsB-dqv383JHQg4eT5LjtmnhSRvBA6-aZnnckYvdZGTPh9G2QwA1adtsvbF0VY-kc1RH_DgoY1jBMHP8HnYOaiI5JCntUSKIq1b6XvOCJRdUUvRPHxp2fZDKu9EWg0GYH0-d73oANGSK7lfzncDsnlLNAAawg39O7fQ
// https://medium.com/@stvehayes/working-with-spotifys-api-to-display-currently-playing-with-react-99544f8797d8
// https://medium.com/@benwiz/how-to-create-a-spotify-refresh-token-the-easy-way-b41a66c7fdd4